import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { Button, Confirm } from "react-admin";

import {
  ArrivedAtIcon,
  CancelIcon,
  PlacedAtIcon,
  ReleasedAtIcon,
} from "../../../components/common/iconography";
import { InboundStatus, InboundState } from "../../../utils/constants";
import { deepRedirect } from "../../../utils/utils";
import { canPlaceInboundShipment } from "../../../utils/shipmentPlacement";
import {
  validateRailcarRelease,
  validateReleaseCommitment,
} from "./InboundUtils";

export const AdvanceButton = ({ record, newStatus, buttonLabel, ...rest }) => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [confirmContent, setConfirmContent] = useState("");
  let display = true;
  let buttonIcon = <ArrivedAtIcon />;

  if (!record) return null;
  if (
    newStatus === InboundStatus.PLACED ||
    newStatus === InboundStatus.SIT_PLACED
  ) {
    buttonIcon = <PlacedAtIcon />;
    display = canPlaceInboundShipment(record);
  } else if (newStatus === InboundStatus.RELEASED) {
    buttonIcon = <ReleasedAtIcon />;

    const isSitPlaced = record.status === InboundStatus.SIT_PLACED;

    const isCompleted =
      record.state === InboundState.COMPLETED ||
      record.state === InboundState.REJECTED;

    // Inventory committed to an outbound blocks the release outright (SIT cars
    // included — their release closes the inventory out the same way), so the
    // button is not offered at all.
    display =
      (isSitPlaced || isCompleted) &&
      !validateReleaseCommitment(record, newStatus);
  }

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    // Check for remaining inventory on release. SIT cars are parked railcars
    // with no on-hand inventory to reconcile, so skip the guard for them.
    const remainingInventory = record.sit
      ? null
      : validateRailcarRelease(record, newStatus);
    if (remainingInventory) {
      setConfirmContent(
        remainingInventory + " of remaining Inventory on hand will be removed!",
      );
      setOpen(true);
    } else {
      handleAdvance();
    }
  };

  const handleDialogClose = () => setOpen(false);

  const handleAdvance = () => {
    const prefillField =
      newStatus === InboundStatus.ARRIVED
        ? "notifyDateTime"
        : newStatus === InboundStatus.PLACED ||
            newStatus === InboundStatus.SIT_PLACED
          ? "placedDateTime"
          : newStatus === InboundStatus.RELEASED
            ? "releaseDateTime"
            : null;
    const state = prefillField
      ? {
          inboundAdvancePrefill: {
            field: prefillField,
            value: new Date(),
          },
        }
      : undefined;
    deepRedirect(
      history,
      `/inboundShipments/${record.id}/dispatch`,
      undefined,
      state,
    );
    setOpen(false);
  };

  if (display) {
    return (
      <>
        <Button label={buttonLabel} color="primary" onClick={handleClick}>
          {buttonIcon}
        </Button>
        {open && (
          <Confirm
            isOpen={open}
            title="Save Confirmation"
            content={confirmContent}
            onConfirm={handleAdvance}
            onClose={handleDialogClose}
            CancelIcon={CancelIcon}
          />
        )}
      </>
    );
  }
  return null;
};
